<template>
    <div class="container">

        <Header icon="fad fa-plus-circle" title="Vytvořit výrobce spotřebiče">
            <template #buttons>
                <BackLinkButton to="/setup/boilers/manufacturers"/>
            </template>
        </Header>

        <BoilerManufacturerForm
            :request="request"
            :is-processing="isCreating"
            v-on:submitted="onSubmitted"
        />

    </div>
</template>

<script>
import {mapGetters} from "vuex"
import ApplianceManufacturerRequest from "../../../NewModel/Appliance/Manufacturer/Request/ApplianceManufacturerRequest"
import BackLinkButton from "../../Common/UI/Button/BackLinkButton.vue"
import BoilerManufacturerForm from "./Component/BoilerManufacturerForm.vue"
import Header from "../../Common/UI/Header.vue"

export default {

    components: {
        BackLinkButton,
        BoilerManufacturerForm,
        Header,
    },

    computed: {
        ...mapGetters({
            isCreating: 'appliance/manufacturers/isCreating',
        }),
    },

    data() {
        return {
            request: new ApplianceManufacturerRequest(),
        }
    },

    methods: {

        /**
         * @param request : ApplianceManufacturerRequest
         */
        onSubmitted(request) {
            this.$store.dispatch("appliance/manufacturers/createManufacturer", request)
                .then(() => {
                    this.successMessage('Úspěšně uloženo!')
                    this.$router.push({name: 'setup_boiler_manufacturer_list'})
                })
                .catch((err) => {
                    this.warningMessage(err.response.message)
                })
        },

    },

}
</script>
